var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DataProviderFactory } from "app/provider/data2.provider";
import { BaseService } from "../views/base.service";
import { HttpClient } from "@angular/common/http";
var BillingService2 = /** @class */ (function (_super) {
    __extends(BillingService2, _super);
    function BillingService2(dpf, http) {
        var _this = _super.call(this, http) || this;
        _this.dpf = dpf;
        _this.http = http;
        _this.balance = _this.dpf.getNew('balance');
        _this.siteBilling = _this.dpf.getNew('billing');
        _this.conversion = _this.dpf.getNew('conversion');
        _this.conversionSource = _this.dpf.getNew('billing/conversion_source');
        _this.conversionRate = _this.dpf.getNew('conversion_rate');
        _this.disableRecurrent = _this.dpf.getNew('billing/disable_recurrent');
        _this.error = _this.dpf.getNew('billing/errors');
        _this.expiredPaid = _this.dpf.getNew('expired_paid');
        _this.promocode = _this.dpf.getNew('promocode');
        _this.geo = _this.dpf.getNew('geo');
        _this.manualPaid = _this.dpf.getNew('manual_paid');
        _this.ones = _this.dpf.getNew('billing/ones');
        _this.return = _this.dpf.getNew('billing/return');
        _this.money = _this.dpf.getNew('money');
        _this.paymentStructure = _this.dpf.getNew('payment_structure');
        _this.domainBilling = _this.dpf.getNew('domain_billing');
        _this.templateBilling = _this.dpf.getNew('template_billing');
        _this.promopultBilling = _this.dpf.getNew('billing/promopult');
        _this.tail = _this.dpf.getNew('billing/tail');
        _this.uber = _this.dpf.getNew('uber');
        _this.withdrawalsRecurrent = _this.dpf.getNew('billing/withdrawals_recurrent');
        _this.beforePaid = _this.dpf.getNew('before_paid');
        _this.operationData = _this.dpf.getNew('operation_data');
        _this.zeroDay = _this.dpf.getNew('billing/zero_day');
        return _this;
    }
    return BillingService2;
}(BaseService));
export { BillingService2 };
